import React from "react";
import "../css/dotNetHeader.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const DesignerHeader = () => {
  const employeeList = [
    {
      id: 1,
      empImage: "/assets/blazordev.jpg",
      empName: "Qaiser Mehmood",
      empRole: "Senior UI/UX Designers",
    },
    {
      id: 2,
      empImage: "/assets/randomUser.png",
      empName: "Ahmad Ali",
      empRole: "Web Designers",
    },
    {
      id: 3,
      empImage: "/assets/randomUser.png",
      empName: "Adeel Baig",
      empRole: "Web Designers",
    },
  ];
  return (
    <div className="dotNetHeader">
      <div className="dotNetHeader-content">
        <h1 className="dotNetHeader_we">
          <span style={{ color: "#0F4C81" }}>
            Top Designers & Creatives for Hire
          </span>
        </h1>
        <div className="dotNetHeader_create-section">
          <div className="dotNetHeader_content_para">
            Get access to the best talent quickly, easily, and securely. Take
            advantage of a simple, smart way to source design talent. With our
            help, you’ll be able to find the right expert within 48 hours.
          </div>
          <div className="dotNetHeader_content_btn">
            <Link to="/hire" className="dotnet_hire_btn">
              Hire a Designer
            </Link>
          </div>
        </div>
      </div>

      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Autoplay]}
        autoplay={true}
        className="dotNetHeader-image"
      >
        {employeeList.map((emp) => (
          <SwiperSlide key={emp.id}>
            <img src={emp.empImage} />
            <div className="person_name">{emp.empName}</div>
            <div className="person_role">{emp.empRole}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DesignerHeader;
